<div class="d-flex flex-column h-100">
  <div class="d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title
      *ngIf="dialogData.mode !== EFormMode.UPDATE"
      class="m-0">{{ 'FILE_UPLOADER.UPLOAD_FILES' | translate }}</h2>
    <h2 mat-dialog-title
      *ngIf="dialogData.mode === EFormMode.UPDATE"
      class="m-0">{{ 'COMMON.FILE_ITEM.UPDATE_TAGS' | translate }}</h2>

    <button mat-icon-button
      [disabled]="isUploading"
      tabindex="-1"
      (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="flex-grow-1">
    <div>
      <bitf-mat-form-option *ngIf="dialogData.mode === EFormMode.UPDATE && formItemsConfig"
        class="w-100"
        appearance="outline"
        matFormFieldClass="w-100"
        [formOptions]="formItemsConfig?.tags"
        [useObject]="true"
        selectFormControlName="tags"
        [form]="form"></bitf-mat-form-option>

      <prada-file-uploader *ngIf="dialogData.mode !== EFormMode.UPDATE"
        [uploadFor]="fsFolderItem"
        [tagsFormItemsConfig]="formItemsConfig?.tags"
        [config]="{isScrollable: true}"
        [fsStore]="dialogData.fsStore"
        (filesUploaded)="onFilesUploaded($event)"
        (isUploadingEvent)="isUploadingEvent($event)"></prada-file-uploader>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="justify-content-end"
    *ngIf="dialogData.mode === EFormMode.UPDATE">
    <button mat-raised-button
      color="primary"
      (click)="onSubmit()">
      {{'COMMON.LABEL.SAVE' | translate}}
    </button>
  </mat-dialog-actions>
</div>